

// import { cosineSimilarity } from "./embeddingUtils";
// import { createEmbedding } from "./embeddingService";
// import { getPolicyIndex } from "./policyIndex";

// export const searchPolicy = async (query) => {
//   const index = getPolicyIndex();
//   if (!index) return null;

//   const qEmbedding = await createEmbedding(query);

//   let best = null;

//   for (const p of index) {
//     const score = cosineSimilarity(qEmbedding, p.embedding);
//     if (!best || score > best.score) {
//       best = { ...p, score };
//     }
//   }

//   return best?.score > 0.7 ? best.text : null;
// };
import { cosineSimilarity } from "./embeddingUtils";
import { createEmbedding } from "./embeddingService";
import { getPolicyIndex } from "./policyIndex";

export const searchPolicy = async (query) => {
  const index = getPolicyIndex();
  if (!index || index.length === 0) return null;

  const qEmbedding = await createEmbedding(query);

  const scored = index.map((p) => ({
    ...p,
    score: cosineSimilarity(qEmbedding, p.embedding),
  }));

  scored.sort((a, b) => b.score - a.score);

  // Very low threshold — catch typos and loose queries
  const THRESHOLD = 0.2;
  const top = scored.filter((p) => p.score >= THRESHOLD).slice(0, 3);

  if (top.length === 0) return null;

  // Pull ALL chunks from same policy as best match
  const bestPolicyName = top[0].text.split("\n")[0];
  const samePolicyChunks = scored.filter(
    (p) => p.text.startsWith(bestPolicyName) && p.score >= 0.1
  );

  // Merge + deduplicate
  const seen = new Set();
  const combined = [...top, ...samePolicyChunks].filter((p) => {
    if (seen.has(p.id)) return false;
    seen.add(p.id);
    return true;
  });

  return combined.map((p) => p.text).join("\n\n---\n\n");
};